import type { DeviceModel } from '../../lib/api/devices';

/**
 * The one thing every device form dialog needs from an `ApiError` and shares
 * no other way: turning `error.details` (field -> messages) into field ->
 * first message. Mirrors `referenceFormHelpers.ts`'s identical `mapDetails`
 * — this module's own copy, not an import across a module boundary, the
 * same duplication `UserFormDialog.tsx`'s own docblock already establishes
 * as this codebase's convention for this exact helper.
 */
export function mapDetails(details: Readonly<Record<string, string[]>>): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [field, messages] of Object.entries(details)) {
    const [first] = messages;
    if (first !== undefined) out[field] = first;
  }
  return out;
}

/**
 * `model.name_ar` in an Arabic session, `model.name_en` everywhere else —
 * the SAME locale rule `SensorList.tsx`'s own `typeLabel()` and
 * `DeviceDetail.tsx`'s own `typeLabel` already apply to a device's OWN
 * `type_label_en`/`type_label_ar`. `DeviceModel` carries the identical pair
 * (`devices.ts`'s own docblock), and the Type dropdowns (the filter bars and
 * `DeviceFormDialog`) are the one place in this module that used to read
 * `name_en` unconditionally — an Arabic agent saw the Type COLUMN in Arabic
 * and the Type FILTER/FIELD in English, in the same table, on the same
 * screen (review finding 2). One function, so the three call sites cannot
 * drift out of step with each other again.
 */
export function deviceModelLabel(model: DeviceModel, language: string): string {
  return language.startsWith('ar') ? model.name_ar : model.name_en;
}
